var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallengerPromotionMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "challenger-promotion-marker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 14V0h14v14zm7-3a4 4 0 100-8 4 4 0 000 8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "challenger-promotion-marker_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 13V1h12v12zm6-2a4 4 0 100-8 4 4 0 000 8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#challenger-promotion-marker_svg__clip-6AA56D27-67CE-44BA-8DB4-1C28CE4308BC)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4C874",
    d: "M7 11a4 4 0 100-8 4 4 0 000 8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F4C874",
    strokeMiterlimit: 20,
    strokeWidth: 6,
    d: "M7 11a4 4 0 100-8 4 4 0 000 8z",
    clipPath: "url(\"#a\")"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#11112a",
    strokeMiterlimit: 20,
    strokeWidth: 4,
    d: "M7 11a4 4 0 100-8 4 4 0 000 8z",
    clipPath: "url(\"#b\")"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/lp-graph/challenger-promotion-marker.svg";
export { SvgChallengerPromotionMarker as ReactComponent };